import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const MultiOfficeRooms5 = props => (
    <ServiceSection noPadTitle singleTitle icon={satelliteIcon} {...props} page="multiOfficeRooms" section="bestPractices">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="multiOfficeRooms:bestPractices" first noPadBottom />
            </div>
        </div>
    </ServiceSection>
);

export default MultiOfficeRooms5;
